export enum EnumStatusSolicitation {
    waiting = "Aguardando",
    approved = "Aprovada",
    rejected = "Rejeitada",
    canceled = "Cancelada",
    paid = "Pago"
}
